import { ArrowDownTrayIcon, XMarkIcon } from '@heroicons/react/20/solid';
import cleanDeep from 'clean-deep';
import { addMonths, format } from 'date-fns';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Actions as TIMESHEET_IMPORT_ACTIONS } from '../../store/actions/timesheetImportActions';
import Spinner from '../common/Spinner';
import DepartmentRow from './DepartmentRow';


const TimesheetTemplateModal = ({
    isModalOpen,
    setTimesheetTemplateModalOpen,
    employeeListWithSalary,
    selectedEmployees,
    downloadTemplate,
    workLocationOptions,
    downloading
}) => {

    const [workLocation, setWorkLocation] = useState();
    const dateOptions = [];

    // Get last month, current month & next 2 months
    for (let i = -1; i < 3; i++) {
        const date = addMonths(new Date(), i);
        dateOptions.push({ label: format(date, "MMMM yyyy"), value: date });
    }

    const [selectedDate, setSelectedDate] = useState(dateOptions[1]);

    // Get all unique departments
    let departments = employeeListWithSalary && employeeListWithSalary.map((employee, index) => ({
        id: index,
        name: employee.departmentName
    })).filter((deptmt, index, self) =>
        index === self.findIndex((dept) => (
            dept.name === deptmt.name
        ))
    );

    // Format data as used in endpoint
    const handleDownloadBtn = () => {
        const month = selectedDate.value.getMonth();
        const year = parseInt(format(selectedDate.value, "yyyy"));
        const employees = [];
        selectedEmployees && selectedEmployees.map((e) => {
            const employee = employeeListWithSalary.find(item => item.id == e)
            employee && employees.push({ agreementId: e, name: employee.employeeName, surname: employee.employeeSurname });
        });
        const dataToSend = cleanDeep({ employees, date: { month: month, year: year }, workLocation });
        downloadTemplate(JSON.stringify(dataToSend));
    };

    if (!isModalOpen)
        return null;

    return (
        <React.Fragment>
            <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                            <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                                <ul className="block-options">
                                    <li>
                                        <button type="button" onClick={setTimesheetTemplateModalOpen}><XMarkIcon className="h-6 w-6 mr-3 text-white" /></button>
                                    </li>
                                </ul>
                                <h3 className="block-title">Download Templates</h3>
                            </div>
                            <div className="block-content" style={{ paddingRight: 0, paddingTop: 0, paddingBottom: 15 }}>
                                <div className="tab-pane active content" id="btabs-alt-static-justified-general">
                                    <span style={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", columnGap: 20 }}>
                                        <span>
                                            <label>Month</label>
                                            <Select
                                                value={selectedDate}
                                                options={dateOptions}
                                                onChange={setSelectedDate}
                                            />
                                        </span>
                                        <span>
                                            <label>Location</label>
                                            <Select
                                                value={workLocation}
                                                options={workLocationOptions}
                                                onChange={setWorkLocation}
                                                isClearable
                                            />
                                        </span>
                                    </span>
                                    <table className="table">
                                        {departments && departments.map((department, index) => {
                                            return (<DepartmentRow department={department} employees={employeeListWithSalary} key={index} />)
                                        })}
                                    </table>
                                    {selectedEmployees.length > 0 
                                        ?
                                            <div 
                                                className="btn btn-success" 
                                                onClick={() => handleDownloadBtn()}
                                            >
                                                {downloading 
                                                    ?
                                                    <>
                                                        <Spinner
                                                            style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                                                            className="animate-spin -ml-1 mr-3 h-5 w-5 "
                                                        />
                                                        <div style={{ float: 'left' }}> Downloading Templates </div>
                                                    </>
                                                    :
                                                    <>
                                                        <ArrowDownTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                                                        <div style={{ float: 'left' }}> Download Templates </div>
                                                    </>
                                                }
                                            </div>
                                        : 
                                            <span>Please select one or more employees.</span>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    const selectedEmployees = Object.entries(state.timesheetImport.employees).filter(employee => employee[1]).map((employee) => employee[0]);
    const workLocations = state.workLocation.types;
    const workLocationOptions = workLocations?.map(w => ({
        label: w.name,
        value: w.id,
        // need id & name for backend
        id: w.id,
        name: w.name,
    }));
    return {
        selectedEmployees,
        isModalOpen: state.timesheetImport.isModalOpen,
        employeeListWithSalary: state.employees.employeeListWithSalary,
        downloading: state.timesheetImport.downloadingPdf,
        workLocationOptions
    }
}

const mapDispatchToProps = dispatch => ({
    setTimesheetTemplateModalOpen: () => dispatch(TIMESHEET_IMPORT_ACTIONS.setTimesheetTemplateModalOpen(false)),
    downloadTemplate: (body) => dispatch(TIMESHEET_IMPORT_ACTIONS.downloadTemplate(body))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TimesheetTemplateModal)